/*
 * ETOLIE — panel filtrów i sortowania listingu (kolekcje, wyszukiwarka, home).
 *
 * 03.09.2026 (ETAP 7, krok 7c): kod wyszedł z inline <script> w
 * snippets/etolie-listing-controls.liquid (15,5 kB w każdym dokumencie listingu i w
 * każdej odpowiedzi Section Rendering) do tego pliku. Ładuje go raz
 * snippets/etolie-luxury.liquid jako klasyczny skrypt z defer — obok
 * assets/etolie-listing.css, które przeszło tą samą drogę w ETAPIE 4.
 *
 * Inline wersja brała swój zakres z document.currentScript. Tutaj zakresem jest
 * argument: etolieSetupListingSection dostaje sekcję, a etolieScanListingControls
 * wyszukuje je po wejściu na stronę i po podmianie sekcji w edytorze motywu
 * (shopify:section:load). Panel dołączony przez Section Rendering trafia więc na
 * stronę, która ten plik już wykonała.
 */

// Kategoria jest innym adresem kolekcji, ale nie zeruje wyboru klientki.
// Parametry śledzenia/podglądu zostają; tylko paginacja zaczyna się od początku.
// 28.09.2026 (N2): domyślne sortowanie strony i „manual” (ręczna kolejność Nowości)
// nie przechodzą do innej kategorii; tam obowiązuje jej własne domyślne.
function etolieListingCategoryURL(rawURL, parameters = null, currentURL = window.location.href, defaultSort = '') {
  const current = new URL(currentURL);
  const url = new URL(rawURL, current);
  current.searchParams.forEach((value, name) => url.searchParams.append(name, value));
  url.searchParams.delete('page');
  if (parameters) {
    Array.from(url.searchParams.keys()).forEach((name) => {
      if (name.startsWith('filter.') || name === 'sort_by') url.searchParams.delete(name);
    });
    parameters.forEach((value, name) => {
      if (name.startsWith('filter.') || name === 'sort_by') url.searchParams.append(name, value);
    });
  }
  const sort = url.searchParams.get('sort_by');
  if (sort === 'manual' || (sort && sort === defaultSort)) url.searchParams.delete('sort_by');
  return `${url.pathname}${url.search}${url.hash}`;
}

function etolieSetupListingSection(lcRoot) {
  if (!lcRoot || lcRoot.dataset.etolieListingReady === 'true') return;
  lcRoot.dataset.etolieListingReady = 'true';

    const lcListing = lcRoot && lcRoot.querySelector('[data-etolie-section-id]');
  // Startowy napis na przycisku ma mówić o kafelkach, które klientka realnie widzi,
  // więc siatkę liczymy z gotowego dokumentu. Inline wersja tego skryptu wykonywała
  // się NAD siatką i musiała czekać na DOMContentLoaded; plik z defer startuje już
  // po sparsowaniu dokumentu, więc siatka jest na miejscu (audyt 02.08.2026).
  let lcGrid = null;
  const lcZnajdzSiatke = () => {
    lcGrid = lcRoot && lcRoot.querySelector('[data-etolie-collection-grid]');
    return lcGrid;
  };

  // Filtry i sortowanie to ten sam komponent: <details> + backdrop + pułapka focusu.
  // Jedna mechanika dla obu, żeby zachowywały się identycznie i nie było dwóch kopii obsługi.
  const filterDetails = lcRoot && lcRoot.querySelector('[data-etolie-filters]');
  const sortDetails = lcRoot && lcRoot.querySelector('[data-etolie-sort]');
  const sheetControls = [filterDetails, sortDetails].filter(Boolean);
  if (!sheetControls.length) return;

  const controlsForm = sheetControls[0].closest('form');
  const usesExternalController = Boolean(controlsForm && controlsForm.dataset.etolieExternalControls);
  const filterPanel = filterDetails && filterDetails.querySelector('.etolie-collection__sheet');
  const filterSubmit = filterDetails && filterDetails.querySelector('[data-etolie-filter-submit]');
  const filterSubmitLabel = filterDetails && filterDetails.querySelector('[data-etolie-filter-submit-label]');
  const sectionId = lcListing && lcListing.dataset.etolieSectionId;
  let resultCountTimer = 0;
  let resultCountRequest = null;
  let resultCountSequence = 0;

  // Przeglądarki potrafią zachować robocze wartości formularza w BFCache. Po
  // „Wstecz” URL i siatka były już poprawne, ale checkbox mógł nadal pokazywać
  // filtr z kolejnej strony. Źródłem zastosowanego stanu jest markup serwera,
  // więc zapamiętujemy atrybuty (nie podatne na browser form restoration).
  const appliedFilterState = new Map();
  const captureAppliedFilterState = (scope = filterDetails) => {
    if (!scope) return;
    scope.querySelectorAll('input').forEach((input) => {
      appliedFilterState.set(input, {
        checked: input.hasAttribute('checked'),
        value: input.getAttribute('value') || '',
      });
    });
  };
  captureAppliedFilterState();

  const restoreAppliedFilterState = () => {
    appliedFilterState.forEach((state, input) => {
      if (!input.isConnected) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = state.checked;
        input.defaultChecked = state.checked;
      } else {
        input.value = state.value;
        input.defaultValue = state.value;
      }
    });
  };

  const setResultCountFallback = () => {
    if (filterSubmitLabel) filterSubmitLabel.textContent = window.etolieT("Pokaż wyniki");
  };

  const setResultCountBusy = (busy) => {
    if (!filterSubmit) return;
    if (busy) filterSubmit.setAttribute('aria-busy', 'true');
    else filterSubmit.removeAttribute('aria-busy');
  };

  const formatResultCount = (count) => window.etolieShowCount(count);

  // Startowy napis na przycisku musi mówić o kafelkach, które klientka realnie widzi.
  const lcStartowyNapis = () => {
    lcZnajdzSiatke();
    // Liczba kafelków opisuje CAŁY wynik tylko wtedy, gdy listing nie jest podzielony
    // na strony. Na stronie 2 z 3 kafelki to wycinek, więc zostaje liczba z serwera.
    const stron = Number((lcGrid && lcGrid.dataset.etoliePages) || 1);
    const maKolejnaStrone = Boolean(lcListing && lcListing.querySelector('[data-etolie-next-page]'));
    if (stron > 1) return;
    if (filterSubmitLabel && lcGrid && !maKolejnaStrone) {
      filterSubmitLabel.textContent = formatResultCount(lcGrid.querySelectorAll('.etolie-card').length);
    }
  };
  lcStartowyNapis();

  const buildResultCountURL = () => {
    if (!(controlsForm instanceof HTMLFormElement) || !sectionId) return null;

    const parameters = new URLSearchParams(new FormData(controlsForm));
    parameters.delete('page');
    if (parameters.get('filter.v.price.gte') === '') parameters.delete('filter.v.price.gte');
    if (parameters.get('filter.v.price.lte') === '') parameters.delete('filter.v.price.lte');

    const requestURL = new URL(controlsForm.action || window.location.pathname, window.location.origin);
    requestURL.search = parameters.toString();
    requestURL.searchParams.set('section_id', sectionId);
    return requestURL;
  };

  const updateResultCount = async (sequence) => {
    if (!(controlsForm instanceof HTMLFormElement) || !controlsForm.checkValidity()) {
      if (sequence === resultCountSequence) {
        setResultCountFallback();
        setResultCountBusy(false);
      }
      return;
    }

    const requestURL = buildResultCountURL();
    if (!requestURL) {
      if (sequence === resultCountSequence) {
        setResultCountFallback();
        setResultCountBusy(false);
      }
      return;
    }

    const controller = new AbortController();
    resultCountRequest = controller;

    try {
      const response = await fetch(requestURL.href, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const hasAnotherPage = Boolean(nextDocument.querySelector('[data-etolie-next-page]'));
      const renderedCount = nextDocument.querySelectorAll('[data-etolie-collection-grid] .etolie-card').length;
      // Shopify filters work at product level. Our grid additionally verifies
      // that size and colour exist on the same available variant, so a narrow
      // result can legitimately contain fewer cards than products reported by
      // Shopify. If the response is the final page, the rendered card count is
      // the exact customer-visible result. 28.09.2026 (N5): for paginated results
      // Shopify's total also counts sold-out products, so the button shows no number.
      if (sequence !== resultCountSequence) return;

      if (filterSubmitLabel) {
        filterSubmitLabel.textContent = hasAnotherPage
          ? window.etolieT("Pokaż wyniki")
          : formatResultCount(renderedCount);
      }
    } catch (error) {
      if (error.name === 'AbortError' || sequence !== resultCountSequence) return;
      setResultCountFallback();
    } finally {
      if (sequence === resultCountSequence) {
        resultCountRequest = null;
        setResultCountBusy(false);
      }
    }
  };

  const queueResultCountUpdate = (delay = 260) => {
    if (usesExternalController) return;
    resultCountSequence += 1;
    const sequence = resultCountSequence;
    window.clearTimeout(resultCountTimer);
    resultCountRequest?.abort();
    resultCountRequest = null;
    setResultCountBusy(true);
    resultCountTimer = window.setTimeout(() => updateResultCount(sequence), delay);
  };

  if (!usesExternalController && filterPanel && controlsForm && filterSubmit && filterSubmitLabel && sectionId) {
    filterPanel.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.type !== 'number') {
        queueResultCountUpdate();
      }
    });
    filterPanel.addEventListener('input', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.type === 'number') {
        queueResultCountUpdate(360);
      }
    });
  } else if (!usesExternalController) {
    setResultCountFallback();
  }

  // Zamknięcie arkusza BEZ „Pokaż wyniki" musi być prawdziwym anulowaniem. Wcześniej
  // zaznaczenia zostawały w formularzu i leciały przy następnym submicie (np. przy kliku
  // w sortowanie), więc klientka dostawała filtry, których świadomie nie zatwierdziła.
  // Wszystkie ścieżki porzucenia (backdrop, ×, Escape, klik obok) idą przez closeSheet.
  const resetPendingFilters = () => {
    if (!filterDetails) return;
    let zmiana = false;
    filterDetails.querySelectorAll('input').forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked !== input.defaultChecked) { input.checked = input.defaultChecked; zmiana = true; }
      } else if (input.value !== input.defaultValue) {
        input.value = input.defaultValue; zmiana = true;
      }
    });
    if (zmiana) {
      queueResultCountUpdate(0);
      updateCategoryLinks();
    }
  };

  const closeSheet = (details, restoreFocus = true) => {
    if (!details) return;
    if (details === filterDetails) resetPendingFilters();
    details.open = false;
    const sheetTrigger = details.querySelector('summary');
    if (restoreFocus && sheetTrigger instanceof HTMLElement) sheetTrigger.focus({ preventScroll: true });
  };

  const syncScrollLock = () => {
    document.documentElement.classList.toggle(
      'etolie-filter-open',
      sheetControls.some((details) => details.open)
    );
  };

  const setupSheet = (details) => {
    if (details.dataset.ready === 'true') return;
    details.dataset.ready = 'true';

    const panel = details.querySelector('.etolie-collection__sheet');
    const sheetFocusTarget = details.querySelector('[data-etolie-sheet-focus]');

    // ETOLIE 04.09.2026 (P1-7, pozycja 5.8): arkusz wchodzi do WARSTWY NAJWYŻSZEJ.
    // Baner zgody Shopify ma z-index 2 000 000, a widżet czatu 2 147 483 000 —
    // żadna wartość z-index motywu tego nie przebije, potrafi to tylko top layer.
    // Atrybut dokłada JS i tylko gdy przeglądarka obsługuje Popover API, więc bez
    // JS i w starszych przeglądarkach markup oraz wygląd są dokładnie jak dotąd.
    // `manual` nie ma własnego light-dismiss ani Escape, więc nie rozjeżdża się
    // z naszym closeSheet; właścicielem stanu zostaje <details>.
    const canTopLayer = panel && typeof panel.togglePopover === 'function';
    if (canTopLayer) panel.setAttribute('popover', 'manual');
    const syncTopLayer = () => {
      if (!canTopLayer) return;
      try {
        if (details.open) {
          if (!panel.matches(':popover-open')) panel.showPopover();
        } else if (panel.matches(':popover-open')) {
          panel.hidePopover();
        }
      } catch (error) { /* przeglądarka odmówiła warstwy — arkusz działa jak dotąd */ }
    };

    details.querySelectorAll('[data-etolie-sheet-close]').forEach((button) => {
      button.addEventListener('click', () => closeSheet(details));
    });

    details.addEventListener('toggle', () => {
      // Reset TUTAJ, nie tylko w closeSheet: zamknięcie klikiem we własną pigułkę „FILTRY"
      // to natywny toggle <details>, który closeSheet omija — porzucone zaznaczenia
      // zostawały w formularzu i leciały przy następnym submicie (audyt 27.07.2026).
      // resetPendingFilters jest idempotentne, więc podwójne wywołanie nie szkodzi.
      if (!details.open && details === filterDetails) resetPendingFilters();
      // Dwa bottom sheety naraz zasłaniałyby się nawzajem — otwarcie jednego zamyka drugi.
      if (details.open) {
        sheetControls.forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
      }
      syncTopLayer();
      syncScrollLock();
      if (details.open && sheetFocusTarget instanceof HTMLElement) {
        window.requestAnimationFrame(() => sheetFocusTarget.focus({ preventScroll: true }));
      }
    });

    // Nasłuch na `document`, nie na `details`: po kliknięciu w tło focus wypadał na <body>,
    // więc Escape i pułapka Tab przestawały działać (regres wobec wersji z 12.07). Handler
    // i tak natychmiast wychodzi przy zamkniętym arkuszu, a otwarcie jednego zamyka drugi.
    document.addEventListener('keydown', (event) => {
      if (!details.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSheet(details);
        return;
      }
      if (event.key !== 'Tab' || !panel) return;

      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element instanceof HTMLElement && element.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  // Puste pola ceny nie mają trafiać do adresu (…?filter.v.price.gte=&filter.v.price.lte=).
  // Zdarzenie formdata łapie i zwykły submit, i requestSubmit(), i podglądowe FormData.
  if (controlsForm instanceof HTMLFormElement) {
    controlsForm.addEventListener('formdata', (event) => {
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
        if (event.formData.get(key) === '') event.formData.delete(key);
      });

      // ETOLIE 04.09.2026: jeden wiersz panelu to RODZINA koloru albo rozmiaru,
      // a Shopify filtruje po surowych wartościach wariantu. Pole niesie wartość
      // główną, resztę rodziny dokłada tutaj `data-etolie-more` — łącznie z 24
      // nazwami, których Shopify nie pokazuje na liście filtra (limit 100 wartości),
      // a po których filtrowanie normalnie działa. Jedno miejsce obsługuje submit,
      // podgląd liczby wyników i kontroler home, bo wszystkie budują FormData z tego
      // formularza. Po włączeniu grup w Search & Discovery atrybutu nie ma i nic
      // się nie dokleja.
      controlsForm.querySelectorAll('input[data-etolie-more]').forEach((input) => {
        if (!input.checked || input.disabled || !input.name) return;
        input.dataset.etolieMore.split('~|~').forEach((value) => {
          if (value) event.formData.append(input.name, value);
        });
      });
    });
  }

  const updateCategoryLinks = (useDraft = false) => {
    if (usesExternalController || !(controlsForm instanceof HTMLFormElement)) return;
    const parameters = useDraft ? new URLSearchParams(new FormData(controlsForm)) : null;
    lcRoot.querySelectorAll('[data-etolie-category-url]').forEach((link) => {
      link.href = etolieListingCategoryURL(link.dataset.etolieCategoryUrl, parameters, window.location.href, controlsForm.dataset.etolieDefaultSort || '');
    });
  };
  updateCategoryLinks();
  controlsForm?.addEventListener('change', () => updateCategoryLinks(true));
  controlsForm?.addEventListener('input', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'number') updateCategoryLinks(true);
  });

  sheetControls.forEach(setupSheet);

  // `pageshow` działa zarówno dla BFCache, jak i zwykłego powrotu. Odtwarzamy
  // faktycznie zastosowany stan, zamykamy ewentualny zapisany arkusz i przeliczamy
  // jego CTA z obecnej siatki; bez nowego requestu i bez zmiany adresu.
  window.addEventListener('pageshow', () => {
    window.clearTimeout(resultCountTimer);
    resultCountRequest?.abort();
    resultCountRequest = null;
    resultCountSequence += 1;
    if (!usesExternalController) restoreAppliedFilterState();
    sheetControls.forEach((details) => { details.open = false; });
    syncScrollLock();
    setResultCountBusy(false);
    lcStartowyNapis();
  });

  // Na desktopie arkusz jest dropdownem — klik poza nim zamyka, jak w każdym menu.
  document.addEventListener('click', (event) => {
    sheetControls.forEach((details) => {
      if (details.open && !details.contains(event.target)) closeSheet(details, false);
    });
  });

  // Próbki kolorów w filtrach biorą kolor z JEDNEGO źródła (etolie-color-map).
  // Inicjalizator działa również po dołączeniu facetów home z kontekstu kolekcji.
  const initializeFilterSwatches = (scope = filterDetails) => {
    if (!scope || !window.etolieColorValue) return;
    // 04.09.2026: próbka siedzi teraz w wierszu rodziny (.etolie-collection__filter-swatch),
    // nie w pigułce. Źródło koloru bez zmian: etolie-color-map.
    scope.querySelectorAll('.etolie-collection__filter-swatch[data-color]').forEach((swatch) => {
      const value = window.etolieColorValue(swatch.dataset.color);
      if (!value) return;
      swatch.style.background = value;
      if (value.indexOf('radial-gradient') !== -1) swatch.style.backgroundSize = '6px 6px';
      const row = swatch.closest('.etolie-collection__filter-option');
      if (row) row.classList.add('has-swatch');
    });
  };
  initializeFilterSwatches();

  // Sekcje panelu są składane i otwarta jest jedna (decyzja Jarka 04.09.2026,
  // wariant A). Serwer NIE ustawia aria-expanded — bez JS panel zostaje rozwinięty
  // i działa jak dotąd; zwijaniem steruje wyłącznie ten kod, a CSS chowa treść
  // dopiero przy html.etolie-progressive-js, więc nie ma mignięcia.
  const FILTER_GROUP_KEY = 'etolie:filtry:sekcja';
  const readOpenFilterGroup = () => {
    try { return window.sessionStorage.getItem(FILTER_GROUP_KEY) || ''; } catch (error) { return ''; }
  };
  const rememberOpenFilterGroup = (key) => {
    try { window.sessionStorage.setItem(FILTER_GROUP_KEY, key); } catch (error) { /* tryb prywatny */ }
  };
  const filterGroupNodes = () => (
    filterDetails ? Array.from(filterDetails.querySelectorAll('[data-etolie-fgroup]')) : []
  );
  const openFilterGroup = (key, remember = true) => {
    filterGroupNodes().forEach((group) => {
      const head = group.querySelector('[data-etolie-fgroup-toggle]');
      if (head) head.setAttribute('aria-expanded', String(group.dataset.etolieFgroup === key));
    });
    if (remember) rememberOpenFilterGroup(key);
  };
  // 18.10.2026 (audyt panelu): po otwarciu sekcji leżącej pod inną rozwiniętą arkusz
  // zostawał przewinięty i pokazywał KONIEC nowej listy (Kolor pod 22 kategoriami →
  // Fioletowy, Żółty, Wzory zamiast Czarny, Biały; nagłówek 877 px nad ekranem na
  // telefonie). Gdy nagłówek otwartej sekcji nie mieści się w arkuszu, arkusz przewija
  // się tak, by stanął pod jego górną krawędzią. Przewija się tylko arkusz, nie strona.
  const scrollFilterGroupIntoView = (group) => {
    const sheet = group.closest('.etolie-collection__sheet');
    const head = group.querySelector('[data-etolie-fgroup-toggle]');
    if (!sheet || !head) return;
    const sheetRect = sheet.getBoundingClientRect();
    const headRect = head.getBoundingClientRect();
    const offset = headRect.top - sheetRect.top;
    if (offset >= 0 && headRect.bottom <= sheetRect.bottom) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sheet.scrollTo({ top: Math.max(0, sheet.scrollTop + offset - 8), behavior: reduce ? 'auto' : 'smooth' });
  };
  const setupFilterGroups = () => {
    const groups = filterGroupNodes();
    if (!groups.length) return;
    groups.forEach((group) => {
      const head = group.querySelector('[data-etolie-fgroup-toggle]');
      if (!head || head.dataset.ready === 'true') return;
      head.dataset.ready = 'true';
      head.addEventListener('click', () => {
        const isOpen = head.getAttribute('aria-expanded') === 'true';
        openFilterGroup(isOpen ? '' : group.dataset.etolieFgroup);
        if (!isOpen) scrollFilterGroupIntoView(group);
      });
    });
    // 29.09.2026: bez zapamiętanej ani aktywnej sekcji panel startuje zwinięty. Otwarta
    // „Kategoria” (21 wierszy) zasłaniała na telefonie Kolor, Rozmiar i resztę sekcji.
    const stored = readOpenFilterGroup();
    const target = groups.find((group) => group.dataset.etolieFgroup === stored)
      || groups.find((group) => group.dataset.etolieFgroupActive === 'true');
    openFilterGroup(target ? target.dataset.etolieFgroup : '', false);
  };
  setupFilterGroups();

  controlsForm?.addEventListener('etolie:facets-updated', (event) => {
    const scope = event.detail?.scope || filterDetails;
    captureAppliedFilterState(scope);
    initializeFilterSwatches(scope);
    // Facety home przychodzą jako nowe węzły, więc sekcje trzeba zbudować od nowa.
    setupFilterGroups();
  });
}

/*
 * ETOLIE 04.09.2026 (ETAP 5, pozycja 5.6): odmiana „produkt / produkty / produktów"
 * miała w JS trzy kopie (ten plik, inline loader kolekcji, kontroler home).
 * Zostaje jedna, tutaj — plik jedzie w <head> na każdym listingu, więc kontroler
 * strumienia zastaje ją gotową. Polska reguła: 1 produkt, 2-4 produkty,
 * 5+ produktów, a 12-14 to wyjątek (dwanaście produktów, nie produkty).
 */
window.etolieProductNoun = function (count) {
  if (!document.documentElement.lang.startsWith('pl')) return window.etolieT(count === 1 ? 'produkt' : 'produkty');
  if (count === 1) return window.etolieT("produkt");
  const mod10 = count % 10;
  const mod100 = count % 100;
  return mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14) ? window.etolieT("produkty") : window.etolieT("produktów");
};

/*
 * 29.09.2026: napis przycisku z liczbą. Po niemiecku czasownik idzie na koniec
 * („15 Produkte anzeigen”), po polsku na początek („Pokaż 15 produktów”).
 */
window.etolieShowCount = function (count, prefix = '') {
  const products = `${prefix}${count} ${window.etolieProductNoun(count)}`;
  const show = window.etolieT('Pokaż');
  return document.documentElement.lang.startsWith('de') ? `${products} ${show.toLowerCase()}` : `${show} ${products}`;
};

// Panel bywa na stronie raz (kolekcja, wyszukiwarka, home), ale zakres liczymy
// per sekcja, żeby dwa listingi na jednym szablonie nie dzieliły stanu.
function etolieScanListingControls(scope) {
  const root = scope instanceof Element || scope instanceof Document ? scope : document;
  root.querySelectorAll('[data-etolie-filters], [data-etolie-sort]').forEach((control) => {
    etolieSetupListingSection(control.closest('.shopify-section'));
  });
}

window.etolieInitListingControls = etolieScanListingControls;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { etolieScanListingControls(); }, { once: true });
} else {
  etolieScanListingControls();
}

document.addEventListener('shopify:section:load', function (event) {
  etolieScanListingControls(event.target);
});

// Same progressive category rail on home, brand pages and collections.
if (!customElements.get('etolie-category-row')) {
  customElements.define('etolie-category-row', class extends HTMLElement {
    static brandId = 0;
    connectedCallback() {
      this.rail = this.querySelector('nav');
      this.previous = this.querySelector('.etolie-category-row__previous');
      this.next = this.querySelector('.etolie-category-row__next');
      if (!this.rail || !this.previous || !this.next) return;
      this.brandToggle = this.querySelector('.etolie-category-row__brands-toggle');
      this.brands = this.querySelector('.etolie-category-row__brands');
      if (this.brandToggle && this.brands) {
        this.brands.id = `etolie-brands-${++this.constructor.brandId}`;
        this.brandToggle.setAttribute('aria-controls', this.brands.id);
        this.brandToggle.hidden = false;
        this.toggleBrands = () => this.setBrandsOpen(this.brands.hidden);
        this.outsideBrands = (event) => {
          if (!this.brands.contains(event.target) && !this.brandToggle.contains(event.target)) this.setBrandsOpen(false);
        };
        this.brandKeydown = (event) => {
          const links = [...this.brands.querySelectorAll('a')];
          if (event.key === 'Escape' && !this.brands.hidden) {
            event.preventDefault();
            this.setBrandsOpen(false);
            this.brandToggle.focus({ preventScroll: true });
          } else if (event.target === this.brandToggle && (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey && !this.brands.hidden))) {
            event.preventDefault();
            this.setBrandsOpen(true);
            links[0]?.focus({ preventScroll: true });
          } else if (event.key === 'Tab' && event.shiftKey && event.target === links[0]) {
            event.preventDefault();
            this.brandToggle.focus({ preventScroll: true });
          } else if (event.key === 'Tab' && !event.shiftKey && event.target === links.at(-1)) {
            event.preventDefault();
            this.setBrandsOpen(false);
            this.brandToggle.nextElementSibling?.focus({ preventScroll: true });
          }
        };
        this.brandFocusout = (event) => {
          if (!this.brands.contains(event.relatedTarget) && event.relatedTarget !== this.brandToggle) this.setBrandsOpen(false);
        };
        this.brandToggle.addEventListener('click', this.toggleBrands);
        this.brandsScroll = () => this.fadeBrands();
        this.brands.addEventListener('scroll', this.brandsScroll, { passive: true });
        this.addEventListener('keydown', this.brandKeydown);
        this.addEventListener('focusout', this.brandFocusout);
        document.addEventListener('pointerdown', this.outsideBrands);
      }
      this.update = () => {
        const maxScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const canGoBack = maxScroll > 2 && this.rail.scrollLeft > 2;
        const canGoForward = maxScroll > 2 && this.rail.scrollLeft < maxScroll - 2;
        const focusedArrow = [this.previous, this.next].includes(document.activeElement) ? document.activeElement : null;
        this.toggleAttribute('data-overflow', maxScroll > 2);
        this.toggleAttribute('data-can-go-back', canGoBack);
        this.toggleAttribute('data-can-go-forward', canGoForward);
        this.previous.hidden = !canGoBack;
        this.next.hidden = !canGoForward;
        if (focusedArrow?.hidden) {
          const target = canGoBack ? this.previous : canGoForward ? this.next : this.rail.querySelector('[aria-current="page"]') || this.rail.querySelector('a');
          target?.focus({ preventScroll: true });
        }
      };
      this.scroll = (direction) => this.rail.scrollBy({ left: direction * Math.max(180, this.rail.clientWidth * .7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.advance = () => this.scroll(1);
      this.goBack = () => this.scroll(-1);
      this.railScroll = () => { this.setBrandsOpen(false); this.update(); };
      this.rail.addEventListener('scroll', this.railScroll, { passive: true });
      this.previous.addEventListener('click', this.goBack);
      this.next.addEventListener('click', this.advance);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.rail);
      this.update();
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
      // 29.10.2026 (test Jarka, 2 tygodnie): przyklejony rząd chowa się przy przewijaniu w dół i wraca przy
      // przewijaniu w górę. Otwarte marki i fokus z klawiatury trzymają go na widoku.
      this.lastY = window.scrollY;
      this.pageScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const y = Math.min(Math.max(0, window.scrollY), document.documentElement.scrollHeight - window.innerHeight);
          const stuck = this.getBoundingClientRect().top <= (parseFloat(getComputedStyle(this).top) || 0) + 1;
          const keep = !stuck || this.hasAttribute('data-brands-open') || Boolean(this.querySelector(':focus-visible'));
          this.toggleAttribute('data-stuck', stuck);
          if (keep) this.removeAttribute('data-scroll-hidden');
          if (Math.abs(y - this.lastY) < 8) return;
          if (!keep) this.toggleAttribute('data-scroll-hidden', y > this.lastY);
          this.lastY = y;
        });
      };
      window.addEventListener('scroll', this.pageScroll, { passive: true });
      // Schowany rząd leży pod nagłówkiem, więc dotyk i myszka go nie trafią; fokus (Tab) odsłania go od razu (kontrola Codexa).
      this.reveal = () => this.removeAttribute('data-scroll-hidden');
      this.addEventListener('focusin', this.reveal);
      this.pageScroll();
    }
    setBrandsOpen(open) {
      if (!this.brands || !this.brandToggle) return;
      this.brands.hidden = !open;
      this.brandToggle.setAttribute('aria-expanded', String(open));
      this.toggleAttribute('data-brands-open', open);
      if (open) {
        this.brands.querySelector('a[aria-current="page"]')?.scrollIntoView({ block: 'nearest', inline: 'center' });
        this.fadeBrands();
      }
    }
    fadeBrands() {
      const max = this.brands.scrollWidth - this.brands.clientWidth;
      const left = this.brands.scrollLeft;
      const fade = max <= 1 ? '' : left <= 1 ? 'end' : left >= max - 1 ? 'start' : 'both';
      if (fade) this.brands.setAttribute('data-fade', fade); else this.brands.removeAttribute('data-fade');
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.rail?.removeEventListener('scroll', this.railScroll);
      this.previous?.removeEventListener('click', this.goBack);
      this.next?.removeEventListener('click', this.advance);
      this.brandToggle?.removeEventListener('click', this.toggleBrands);
      this.brands?.removeEventListener('scroll', this.brandsScroll);
      this.removeEventListener('keydown', this.brandKeydown);
      this.removeEventListener('focusout', this.brandFocusout);
      document.removeEventListener('pointerdown', this.outsideBrands);
      window.removeEventListener('scroll', this.pageScroll);
      this.removeEventListener('focusin', this.reveal);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
